module.exports = __webpack_public_path__ + "img/Honig-aus-2021-380.0634fc76.jpg";